// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dMlv","col":"styles_col__37COU"};